import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconNetwork } from "@tabler/icons-react";
import { CadenasDef } from "./CadenasDef";

export const CadenasHelpText = '* Aquí puede ver la lista de todas las cadenas de tiendas disponibles. Una cadena puede estar relacionada con un solo grupo de empresas.';
export const CadenasIcon = IconNetwork;

export class Cadenas extends Entity<CadenasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new CadenasDef(), parentKeys);
        this.Form = "AutoForm";
        this.HelpText = CadenasHelpText;
        this.Icon = CadenasIcon
    }
}